export default {"src":"/_next/static/media/energy-boosters.c41495c9.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};